import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { List, ListItem } from "@sainsburys-tech/fable";
import { Tick } from '@sainsburys-tech/icons'

const CurrentStepIcon = props => (
  <span className="cb-c-store-commissioning-stepper__step-icon--current fable:text-2xl fable:text-center">
    {props.stepNumber}
  </span>
);

const CompletedStepIcon = () => (
  <Tick className="cb-c-store-commissioning-stepper__step-icon--completed" />
);

const IncompleteStepIcon = props => (
  <span className="cb-c-store-commissioning-stepper__step-icon--incomplete fable:text-2xl fable:text-center">
    {props.stepNumber}
  </span>
);

const Step = props => {
  return (
    <ListItem className="cb-c-store-commissioning-stepper__step">
      <span className="fable:inline-block">
        <div className="fable:text-2xl">
          <span>{props.icon}</span>
          <Link
            to={props.url}
            className={
              props.disabled
                ? "cb-c-store-commissioning-stepper__step-icon--disabled"
                : null
            }
          >
            {props.name}
          </Link>
        </div>
      </span>
    </ListItem>
  );
};

const StepConnector = () => (
  <ListItem className="cb-c-store-commissioning-stepper__step">
    <span className="fable:inline-block cb-c-store-commissioning-stepper__step-connector" />
  </ListItem>
);

const StoreCommissioningStepper = props => (
  <List className="cb-c-store-commissioning-stepper__stepper">
    {props.steps.map((step, index) => {
      const stepNumber = index + 1;
      return (
        <React.Fragment key={stepNumber}>
          <Step
            url={step.url}
            name={step.name}
            icon={
              props.currentStep === index ? (
                <CurrentStepIcon stepNumber={stepNumber} />
              ) : step.isCompleted ? (
                <CompletedStepIcon />
              ) : (
                <IncompleteStepIcon stepNumber={stepNumber} />
              )
            }
            key={stepNumber}
            disabled={step.isDisabled}
          />
          {stepNumber < props.steps.length && <StepConnector />}
        </React.Fragment>
      );
    })}
  </List>
);

StoreCommissioningStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      isCompleted: PropTypes.bool.isRequired,
      isDisabled: PropTypes.bool.isRequired
    })
  ),
  currentStep: PropTypes.number.isRequired
};

export default StoreCommissioningStepper;
